import API from "../api/manager";
import config from "../api/config";

const eventInfo = (data) => {
  return API({
    method: "POST",
    url: config.urls.events.eventInfo,
    data,
  });
};

const getEvent = (id, type) => {
  return API(
    {
      method: "GET",
      url: config.urls.events.eventInfo + `/${id}?requestType=${type}`,
    },
    false,
  );
};

const eventInfoEventViewerLive = (id, type) => {
  return API(
    {
      method: "GET",
      url:
        config.urls.events.eventInfoEventViewerLive +
        `/${id}?requestType=${type}`,
    },
    true,
  );
};

const updateEvent = (id, data) => {
  return API({
    method: "PUT",
    url: config.urls.events.eventInfo + `/${id}`,
    data,
  });
};

const getEventInfo = () => {
  return API({
    method: "GET",
    url: config.urls.events.eventInfo,
  });
};

const eventLoginViewer = (data) => {
  return API(
    {
      method: "POST",
      url: config.urls.events.EventViewerLogin,
      data,
    },
    false,
  );
};

const getRegister = (id) => {
  return API(
    {
      method: "GET",
      url: config.urls.events.viewer + `/${id}`,
    },
    false,
  );
};

const updateRegister = (id, data) => {
  return API(
    {
      method: "POST",
      url: config.urls.events.viewer + `/${id}`,
      data,
    },
    false,
  );
};

const saveEventQuestions = (data) => {
  return API({
    method: "POST",
    url: config.urls.events.saveEventQuestions,
    data,
  });
};

const saveEventAnswers = (data) => {
  return API({
    method: "POST",
    url: config.urls.events.saveEventAnswers,
    data,
  });
};

const saveEventFeedback = (data) => {
  return API({
    method: "POST",
    url: config.urls.events.saveEventFeedback,
    data,
  });
};

const getqadashboard = (id) => {
  return API({
    method: "GET",
    url: config.urls.events.getqadashboard + `/${id}`,
  });
};

const updateqadashboard = (id, data) => {
  return API({
    method: "PUT",
    url: config.urls.events.putqadashboard + `/${id}`,
    data,
  });
};

const viewerPolling = (data) => {
  return API(
    {
      method: "POST",
      url: config.urls.events.polling,
      data,
    },
    false,
  );
};

const getqadashboardViewer = (data) => {
  return API({
    method: "POST",
    url: config.urls.events.getqadashboardforeventviewer,
    data,
  });
};

const readPutAaDashboard = (data) => {
  return API({
    method: "PUT",
    url: config.urls.events.putqadashboard,
    data,
  });
};

const getFeedback = (data) => {
  return API({
    method: "POST",
    url: config.urls.events.geteventviewerfeedbackdetails,
    data,
  });
};

const getEventMetricsEventsList = (data) => {
  return API({
    method: "POST",
    url: config.urls.events.getEventMetricsEventsList,
    data,
  });
};

const copyGivenEvent = (data) => {
  return API({
    method: "POST",
    url: config.urls.events.copyGivenEvent,
    data,
  });
};

const updateEventStatus = (eventId, data) => {
  return API({
    method: "PUT",
    url: config.urls.events.updateStatus + `/${eventId}`,
    data,
  });
};

const updateQandA = (eventId, data) => {
  return API({
    method: "PUT",
    url: config.urls.events.putqadashboard + `/${eventId}`,
    data,
  });
};

const getEventInfoData = (eventId) => {
  return API({
    method: "GET",
    url: config.urls.events.eventMeta + `/${eventId}`,
  });
};

const sendEmail = (data) => {
  return API({
    method: "POST",
    url: config.urls.events.preViewSendemail,
    data,
  });
};

const getCopyFromTemplate = (orgId) => {
  return API({
    method: "GET",
    url: config.urls.eventManager.copyTemplate + `/${orgId}`,
  });
};

const reschedleGivenEvent = (data) => {
  return API({
    method: "POST",
    url: config.urls.events.reschedleGivenEvent,
    data,
  });
};

const galleryLogin = (id, data) => {
  return API(
    {
      method: "POST",
      url: config.urls.events.registergallery + `/${id}`,
      data,
    },
    false,
  );
};

const agmEventViewerLive = (id, type) => {
  return API(
    {
      method: "GET",
      url:
        config.urls.events.eventInfoEventViewerLive +
        `/${id}?requestType=${type}`,
    },
    false,
  );
};

export default {
  eventInfo,
  getEvent,
  updateEvent,
  getEventInfo,
  eventLoginViewer,
  getRegister,
  updateRegister,
  saveEventQuestions,
  saveEventAnswers,
  saveEventFeedback,
  getqadashboard,
  updateqadashboard,
  viewerPolling,
  getqadashboardViewer,
  readPutAaDashboard,
  getFeedback,
  getEventMetricsEventsList,
  copyGivenEvent,
  updateEventStatus,
  updateQandA,
  getEventInfoData,
  sendEmail,
  getCopyFromTemplate,
  eventInfoEventViewerLive,
  reschedleGivenEvent,
  galleryLogin,
  agmEventViewerLive,
};
